import { render } from "./Itemcard.vue?vue&type=template&id=34fc0b88"
import script from "./Itemcard.vue?vue&type=script&lang=js"
export * from "./Itemcard.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\PC1\\Local Sites\\jpburato.now.sh.dev\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__